module.exports = __webpack_public_path__ + "img/ActivateWarranty-Icon.c45ae234.svg";